import React from 'react'
import { useToast } from '@/hooks/use-toast.tsx'
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react'
import { cn } from '@/lib/utils'

const icons = {
  success: <CheckCircle className="h-5 w-5" />,
  error: <XCircle className="h-5 w-5" />,
  warning: <AlertTriangle className="h-5 w-5" />,
  info: <Info className="h-5 w-5" />,
}

const toastColors = {
  success: 'bg-green-500',
  error: 'bg-red-500',
  warning: 'bg-yellow-500',
  info: 'bg-blue-500',
}

export const Toaster: React.FC = () => {
  const { toasts, hideToast } = useToast()

  if (toasts.length === 0) {
    return null
  }

  return (
    <div className="fixed top-4 right-4 z-[100] w-full max-w-sm space-y-3">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={cn(
            'relative flex items-start space-x-4 p-4 rounded-lg shadow-lg text-white',
            toastColors[toast.type]
          )}
        >
          <div className="flex-shrink-0">{icons[toast.type]}</div>
          <div className="flex-1">
            <p className="font-bold">{toast.title}</p>
            {toast.description && (
              <p className="text-sm mt-1">{toast.description}</p>
            )}
          </div>
          <button
            onClick={() => hideToast(toast.id)}
            className="p-1 rounded-full hover:bg-white/20 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  )
}
